import { render, staticRenderFns } from "./SportStoreContainer.vue?vue&type=template&id=5bf80224&scoped=true"
import script from "./SportStoreContainer.vue?vue&type=script&lang=js"
export * from "./SportStoreContainer.vue?vue&type=script&lang=js"
import style0 from "./SportStoreContainer.vue?vue&type=style&index=0&id=5bf80224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf80224",
  null
  
)

export default component.exports